export const environment = {
    production: true,
    urlApi: 'https://boahora.med.br/new_api/service/',
    urlEmail: 'https://boahora.med.br/new_api/email/envia.php',
    urlCalendar: 'https://boahora.med.br/new_api/calendar/calendar.php',
    termo: 'https://boahora.med.br/new_api/termo/index.php',
    certificado : 'https://boahora.med.br/new_api/email/certificado.php'
};
